var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 24C5.4 24 0 18.6 0 12C0 5.4 5.4 0 12 0C18.6 0 24 5.4 24 12C24 18.6 18.6 24 12 24ZM12 1.5C6.225 1.5 1.5 6.225 1.5 12C1.5 17.775 6.225 22.5 12 22.5C17.775 22.5 22.5 17.775 22.5 12C22.5 6.225 17.775 1.5 12 1.5ZM16.575 8.6625C17.1 8.625 17.55 8.475 18 8.2875C17.6625 8.775 17.25 9.225 16.8 9.5625V9.8625C16.8 13.125 14.325 16.875 9.7875 16.875C8.4 16.875 7.0875 16.5 6 15.7875C6.1875 15.825 6.41249 15.825 6.59999 15.825H6.6C7.7625 15.825 8.85 15.45 9.675 14.775C8.625 14.7375 7.6875 14.025 7.3875 13.05C7.5375 13.0875 7.68749 13.0875 7.83749 13.0875H7.8375C8.03392 13.0875 8.20177 13.0589 8.39093 13.0267C8.41845 13.022 8.44642 13.0173 8.475 13.0125C7.35 12.7875 6.4875 11.8125 6.4875 10.6125V10.575C6.825 10.7625 7.2 10.875 7.6125 10.875C6.975 10.425 6.525 9.675 6.525 8.8125C6.525 8.3625 6.6375 7.95 6.8625 7.575C8.0625 9.075 9.8625 10.05 11.925 10.1625C11.8875 9.975 11.85 9.7875 11.85 9.6C11.85 8.2125 12.975 7.125 14.325 7.125C15 7.125 15.6375 7.425 16.0875 7.9125C16.65 7.8 17.175 7.6125 17.6625 7.3125C17.475 7.875 17.1 8.3625 16.575 8.6625Z",
    fill: "#3F3B3B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.365eb975.svg";
export { ForwardRef as ReactComponent };